module.exports = __webpack_public_path__ + "static/media/salmah-handout.aa6e5393.pdf";